import {
  DECISION_FOLDER_ADD,
  FOLDERS_SET,
  FOLDER_CREATED,
  FOLDER_DELETED,
  FOLDER_RENAMED,
} from '../action-types';
import { LatestUpdatedReducerType } from '../foldersState.types';
import { FolderActions, DecisionActions } from '../actions';

const initialState: LatestUpdatedReducerType = { folders: [] };

export function latestUpdatedReducer(
  state: LatestUpdatedReducerType = initialState,
  action: FolderActions | DecisionActions,
) {
  switch (action.type) {
    case FOLDERS_SET: {
      const { folders } = action.payload;
      const newFolderIds = Object.keys(folders).filter(
        (id: string) => !state.folders.includes(id),
      );
      return { folders: [...newFolderIds, ...state.folders] };
    }
    case DECISION_FOLDER_ADD:
    case FOLDER_RENAMED: {
      const { folderKey } = action.payload;
      const newFolders = state.folders.filter((id) => id !== folderKey);
      return { ...state, folders: [folderKey].concat(newFolders) };
    }
    case FOLDER_DELETED: {
      const { folderKey } = action.payload;
      return {
        ...state,
        folders: state.folders.filter((id) => id !== folderKey),
      };
    }
    case FOLDER_CREATED: {
      const { folder } = action.payload;
      return {
        ...state,
        folders: [folder.folderKey].concat(state.folders),
      };
    }

    default:
      return state;
  }
}
